import { Checkbox, Col, Form, Icon, Row, Select } from 'antd'
import CustomSpin from 'elements/CustomSpin'
import useFetch from 'elements/Hooks/useFetch'
import useFetchSelect from '../elements/Hooks/useFetchSelect'
import AddPhoneBook from '../components/Main/Modal/AddPhoneBook'
import CentersCascader from '../elements/Cascader/CentersCascader'
import FormSectionTitle from '../elements/FormSectionTitle'
import withSort from '../elements/HOC/withSort'
import withSpinning from '../elements/HOC/withSpinning'
import useFetchSelectUrl from '../elements/Hooks/useFetchSelectUrl'
import useModalShow from '../elements/Hooks/useModalShow'
import CustomDebounceSelect from '../elements/Select/CustomDebounceSelect'
import OrganisationsSelect from '../elements/Select/Organistaions'
import withUrlFetch from '../elements/Select/withUrlFetch'
import { attempt, get, isEmpty } from 'lodash'
import Authentication from '../modules/Authentication'

import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../modules/FormItems'
import { normalizeNull, strVal } from '../modules/Utils'
import React, { Fragment, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { GlobalContext } from 'Global'

const VendorSelect = compose(
  withUrlFetch({
    name: 'suppliers',
    url: `/suppliers`,
  }),
  withSpinning,
  withSort
)(CustomDebounceSelect)

const auth = new Authentication()

function getSales(doc, client) {
  const value = get(doc, client) || ''
  // console.log(value, value.includes('members'), value.includes('partners'))
  if (value.includes('members')) return get(doc, client)
  if (value.includes('partners')) return get(doc, 'client.owner')
  return value
}

function RegisteredPartnerDetails(props) {
  const { tenantOptions, member } = React.useContext(GlobalContext)
  const {
    getFieldDecorator,
    getFieldValue,
    setFieldsValue,
    doc,
    defaultCompany,
    type,
    title,
    vendorID,
    showProfit,
    showCost,
    accountType,
    isOnline = false,
    showRepEmail = false,
    viewOnly,
  } = props

  const attributesMap = {
    enquiry: {
      isExistingVendor: 'isExistingClient',
      vendor: 'enquirer._id',
      vendorRep: 'enquirer_rep._id',
      company: 'company._id',
      companyRep: 'sales_rep._id',
      companyRepEmail: 'sales_rep.email.label',
      contract: 'contract._id',
      profit: 'centers',
      cost: 'centers',
    },
    rfq: {
      isExistingVendor: 'isExistingVendor',
      vendor: 'vendor._id',
      vendorRep: 'vendorRep._id',
      company: 'company._id',
      companyRep: 'companyRep._id',
      companyRepEmail: 'companyRep.email.label',
      contract: 'contract._id',
      profit: 'centers',
      cost: 'centers',
    },
    vendorQuote: {
      isExistingVendor: 'isExistingVendor',
      vendor: 'vendor._id',
      vendorRep: 'vendorRep._id',
      company: 'company._id',
      companyRep: 'companyRep._id',
      companyRepEmail: 'companyRep.email.label',
      contract: 'contract._id',
      profit: 'centers',
      cost: 'centers',
    },
    quote: {
      isExistingVendor: 'isExistingClient',
      vendor: 'enquirer._id',
      vendorRep: 'enquirerRep._id',
      company: 'company._id',
      companyRep: 'companyRep._id',
      companyRepEmail: 'companyRep.email.label',
      contract: 'contract._id',
      profit: 'centers',
      cost: 'centers',
    },
    sales: {
      isExistingVendor: 'isExistingClient',
      vendor: isOnline ? 'client._id' : 'client.member._id',
      vendorRep: 'clientRep._id',
      company: 'company._id',
      companyRep: 'companyRep._id',
      companyRepEmail: 'companyRep.email.label',
      contract: 'contract._id',
      profit: 'centers',
      cost: 'centers',
    },
    purchase: {
      isExistingVendor: 'isExistingVendor',
      vendor: 'vendor._id',
      vendorRep: 'vendorRep._id',
      company: 'company._id',
      companyRep: 'companyRep._id',
      companyRepEmail: 'companyRep.email.label',
      contract: 'contract._id',
      profit: 'centers',
      cost: 'centers',
    },
    requisitions: {
      isExistingVendor: 'isExistingClient',
      vendor: 'client._id',
      vendorRep: 'clientRep._id',
      company: 'company._id',
      companyRep: 'companyRep._id',
      companyRepEmail: 'companyRep.email.label',
      contract: 'contract._id',
      profit: 'centers',
      cost: 'centers',
    },
  }

  const attrMap = attributesMap[type]

  const [client, setClient] = useState({})
  const clientKind = get(client, 'member.kind')
  const isClientIndividual = clientKind === 'individual'
  const vendor =
    type === 'sales'
      ? isOnline
        ? getSales(doc, attrMap.vendor)
        : get(client, isOnline ? 'client._id' : 'owner')
      : getFieldValue(attrMap.vendor) || ''

  const company = getFieldValue(attrMap.company) || ''

  let isExistingVendor
  let disabledValue = false
  let partnerContractDisabled = false
  let allDisabled = false
  if (viewOnly) {allDisabled = true}
  if (type === 'sales') {
    isExistingVendor = true
    partnerContractDisabled = true
  } else {
    isExistingVendor = !!getFieldValue(attrMap.isExistingVendor)
  }
  if (partnerContractDisabled === true || allDisabled === true) {disabledValue = true}

  const [modalID, setModalID] = useState(1)
  const { visible: visiblePhonebook, onShow: onShowPhoneBook, onCancel: onCancelPB } = useModalShow()

  function onCancelPhoneBook() {
    setModalID((old) => old + 1)
    onCancelPB()
  }

  const { data: vendorData = {}, fetching } = useFetch({
    url: vendor,
    dependencyArray: [vendor],
    dontFetch: isEmpty(vendor),
  })

  const isVendorIndividual = vendorData.kind === 'individual'

  const MembersSelect = compose(
    withUrlFetch({
      name: 'members',
      //url: 'members/list?select=fn,_key,_id,kind&kind=organisation',
      url: 'members/list?select=fn,_key,_id,kind',
    }),
    withSpinning,
    withSort
  )(CustomDebounceSelect)

  const { SelectData: VendorRepSelect } = useFetchSelect({
    url: `${vendor}/representatives`,
    dependencyArray: [vendor],
    dontFetch: isEmpty(vendor),
  })

  const { SelectData: ClientsListSelect } = useFetchSelect({ url: 'clients?status=Active' })

  const { SelectData: PurchaseContractsSelect } = useFetchSelect({
    url: `/purchaseContracts?select=*&status=Approved&owner=${vendor}&company=${company}&state=active${
      accountType ? `&type=${accountType}` : ''
    }`,
    dependencyArray: [vendor, company],
    dontFetch: isEmpty(vendor) && isEmpty(company),
    mapFunction: (c) => ({
      ...c,
      display: `[${c.code}]  ${c.title} - ${c?.company?.fn}`,
    }),
  })

  const sellContractURL =
    type === 'requisitions'
      ? `clients/${vendor.replace('partners/', '')}/contracts?company=${company}&status=Approved&state=active`
      : isOnline
      ? 'salesContracts/?select=_id,code,title,company&state=active'
      : `salesContracts/?select=*&owner=${vendor}&company=${company}&state=active`

  const { SelectData: SellContractsSelect } = useFetchSelect({
    url: sellContractURL,
    dependencyArray: [vendor, company],
    dontFetch: isEmpty(vendor) && isEmpty(company),
    mapFunction: (c) => ({
      ...c,
      display: `[${c.code}]  ${c.title} - ${c?.company?.fn}`,
    }),
  })

  const { SelectData: CompanyRepSelect } = useFetchSelect({
    url: `members/${company.replace('members/', '')}/representatives`,
    dependencyArray: [company],
    dontFetch: isEmpty(company),
  })

  const companyRep = getFieldValue(attrMap.companyRep) || get(doc, attrMap.companyRep, '')

  const { SelectData: CompanyRepEmailSelect, data: CompanyRepEmails } = useFetchSelect({
    url: `contacts/email/${(companyRep || '').replace('members/', '')}`,
    dependencyArray: [companyRep],
    dontFetch: isEmpty(companyRep),
  })

  // useEffect(() => {
  //   if (CompanyRepEmails) {
  //     const defaultEmail = CompanyRepEmails.find((i) => i.default)
  //     setFieldsValue({ [attrMap.companyRepEmail]: defaultEmail?.label })
  //   }
  // }, [getFieldValue(attrMap.companyRep), CompanyRepEmails])

  return (
    <Fragment>
      <AddPhoneBook
        key={modalID}
        visible={visiblePhonebook}
        handleCancel={onCancelPhoneBook}
        handleOk={onCancelPhoneBook}
      />

      {title && <FormSectionTitle title={title} />}

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Company">
            {getFieldDecorator(attrMap.company, {
              initialValue: get(doc, attrMap.company) || defaultCompany,
              rules: rules.select,
            })(<OrganisationsSelect disabled={disabledValue} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          {getFieldValue(attrMap.company) && (
            <Form.Item {...defaultFormItemLayout} label="Company Rep">
              {getFieldDecorator(attrMap.companyRep, {
                initialValue: get(doc, attrMap.companyRep) || get(member, '_id'),
                rules: rules.select,
              })(
                <CompanyRepSelect
                  placeholder="Received By"
                  keyAtr={'_id'}
                  valueAtr={'name'}
                  style={{ width: '100%' }}
                  //disabled={disabledValue}
                />
              )}
            </Form.Item>
          )}
        </Col>

        {getFieldValue(attrMap.companyRep) && showRepEmail && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Contact Person Email">
              {getFieldDecorator(attrMap.companyRepEmail, {
                initialValue: get(doc, attrMap.companyRepEmail),
                rules: rules.select,
              })(<CompanyRepEmailSelect valueAtr={'label'} keyAtr={'label'} />)}
            </Form.Item>
          </Col>
        )}
      </Row>
      {type !== 'sales' && (
        <Row>
          <Col span={24}>
            <Form.Item
              {...fullWidthFormItemLayout}
              label={
                ['enquiry', 'quote', 'sales', 'requisitions'].includes(type) ? 'Registered Client' : 'Registered Vendor'
              }>
              {getFieldDecorator(attrMap.isExistingVendor, {
                initialValue: get(doc, attrMap.isExistingVendor, true),
                valuePropName: 'checked',
              })(<Checkbox disabled={['purchase'].includes(type) || disabledValue } />)}
              <span>
                <b>
                  &nbsp;&nbsp;To register a{' '}
                  {['enquiry', 'quote', 'sales', 'requisitions'].includes(type) ? 'New Client' : 'New Vendor'}, complete
                  the online registration page by{' '}
                  <a
                    //href={`https://client.${auth.getMember().tenantGroup.baseURL}`}
                    href={`https://client.${get(member, 'tenantGroup.baseURL')}`}
                    target={'_blank'}
                    rel="noopener noreferrer">
                    clicking here
                  </a>
                </b>
              </span>
            </Form.Item>
          </Col>
        </Row>
      )}
      {!isExistingVendor && (
        <Row>
          <Col span={12}>
            <Form.Item
              {...defaultFormItemLayout}
              label={
                ['enquiry', 'quote', 'sales', 'requisitions'].includes(type)
                  ? `${type === 'requisitions' ? 'Client' : 'Enquirer'}`
                  : 'Vendor'
              }>
              {getFieldDecorator(attrMap.vendor, {
                initialValue: get(doc, attrMap.vendor) || vendorID || '',
                rules: rules.select,
              })(
                <MembersSelect
                  disabled={disabledValue}
                  keyAtr={'_id'}
                  valueAtr={'fn'}
                  placeholder={
                    ['enquiry', 'quote', 'sales', 'requisitions'].includes(type)
                      ? `Select an ${type === 'requisitions' ? 'Client' : 'Enquirer'}`
                      : 'Select a Vendor'
                  }
                  style={{ width: '85%' }}
                />
              )}
              <Icon style={{ marginLeft: 5 }} type="plus-circle" onClick={onShowPhoneBook} />
            </Form.Item>
          </Col>
          <Col span={12}>
            {vendor && !isVendorIndividual && (
              <CustomSpin spinning={fetching}>
                <Form.Item {...defaultFormItemLayout} label="Contact Person">
                  {getFieldDecorator(attrMap.vendorRep, {
                    initialValue: get(doc, attrMap.vendorRep),
                  })(<VendorRepSelect disabled={disabledValue} keyAtr={'_id'} style={{ width: '85%' }} valueAtr={'name'} />)}
                  <Icon style={{ marginLeft: 5 }} type="plus-circle" onClick={onShowPhoneBook} />
                </Form.Item>
              </CustomSpin>
            )}
          </Col>
        </Row>
      )}
      {isExistingVendor && (
        <Row>
          <Col span={12}>
            <Form.Item
              {...defaultFormItemLayout}
              label={['enquiry', 'quote', 'sales', 'requisitions'].includes(type) ? 'Client' : 'Vendor'}>
              {getFieldDecorator(attrMap.vendor, {
                initialValue: type === 'sales' ? getSales(doc, attrMap.vendor) : get(doc, attrMap.vendor),
                rules: rules.select,
              })(
                ['enquiry', 'quote', 'sales', 'requisitions'].includes(type) ? (
                  isOnline ? (
                    <MembersSelect
                      keyAtr={'_id'}
                      valueAtr={'fn'}
                      placeholder={'Select a Client'}
                      style={{ width: '85%' }}
                      disabled={disabledValue}
                      // setSelected={setClient}
                    />
                  ) : (
                    <ClientsListSelect
                      valueAtr={'member.fn'}
                      keyAtr={type === 'requisitions' ? '_id' : 'owner'}
                      placeholder={'Select a Client'}
                      style={{ width: '85%' }}
                      disabled={disabledValue}
                      setSelected={setClient}
                    />
                  )
                ) : (
                  <VendorSelect
                    disabled={disabledValue}
                    keyAtr={'owner'}
                    valueAtr={'fn'}
                    placeholder="Select a Vendor"
                    style={{ width: '85%' }}
                  />
                )
              )}
              <Link
                target={'_blank'}
                to={`/${
                  ['enquiry', 'quote', 'sales', 'requisitions'].includes(type) ? 'clients' : 'purchasing/suppliers'
                }/${strVal(doc, attrMap.vendor).replace('members/', '')}/`}>
                <Icon style={{ marginLeft: 5 }} type="fullscreen" />
              </Link>
            </Form.Item>
          </Col>
          {vendor && !isClientIndividual && !isOnline && (
            <Col span={12}>
              <Form.Item
                {...defaultFormItemLayout}
                label={['enquiry', 'quote', 'sales', 'requisitions'].includes(type) ? 'Client Rep' : 'Vendor Rep'}>
                {getFieldDecorator(attrMap.vendorRep, {
                  normalize: normalizeNull,
                  initialValue: get(doc, attrMap.vendorRep),
                  rules: rules.select,
                })(<VendorRepSelect keyAtr={'_id'} valueAtr={'name'} style={{ width: '85%' }} />)}
                <Icon style={{ marginLeft: 5 }} type="plus-circle" onClick={onShowPhoneBook} />
              </Form.Item>
            </Col>
          )}
        </Row>
      )}

      {vendor && company && vendor !== company && (
        <Row>
          {isExistingVendor && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Select an Account">
                {getFieldDecorator(attrMap.contract, {
                  initialValue: get(doc, attrMap.contract),
                  rules: type === 'purchase' && rules.select,
                })(
                  ['enquiry', 'quote', 'sales', 'requisitions'].includes(type) ? (
                    <SellContractsSelect
                      disabled={disabledValue}
                      keyAtr={'_id'}
                      valueAtr={'display'}
                      placeholder={'Account'}
                    />
                  ) : (
                    <PurchaseContractsSelect disabled={disabledValue} keyAtr={'_id'} valueAtr={'display'} placeholder={'Account'} />
                  )
                )}
              </Form.Item>
            </Col>
          )}
          {showProfit && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Profit Center">
                {getFieldDecorator(attrMap.profit, {
                  initialValue: get(doc, attrMap.profit),
                  rules: rules.select,
                })(
                  <CentersCascader
                    key={getFieldValue(attrMap.company)}
                    category={'Profit'}
                    company={getFieldValue(attrMap.company)}
                    disabled={disabledValue}
                  />
                )}
              </Form.Item>
            </Col>
          )}
          {showCost && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Cost Center">
                {getFieldDecorator(attrMap.cost, {
                  initialValue: get(doc, attrMap.cost),
                  rules: rules.select,
                })(
                  <CentersCascader
                    key={getFieldValue(attrMap.company)}
                    category={'Cost'}
                    company={getFieldValue(attrMap.company)}
                    disabled={disabledValue}
                  />
                )}
              </Form.Item>
            </Col>
          )}
        </Row>
      )}
    </Fragment>
  )
}

export default RegisteredPartnerDetails
